import withTitle from './withTitle';
export default withTitle;
